import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IScanSummary } from '../../../../../../../shared/interfaces/scan-summaries.interface';

@Component({
  selector: 'app-view-scan-results-accessibility-health',
  templateUrl: './view-scan-results-accessibility-health.component.html',
  styleUrls: ['./view-scan-results-accessibility-health.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ViewScanResultsAccessibilityHealthComponent {
  @Input() public scanSummary: IScanSummary;
  @Input() public previousScanSummary: IScanSummary;

  constructor() {
    this.scanSummary = null;
  }
}
